module.exports = new __parcel__URL__("design-details-popup.tpl.da785a24.svg").toString();